import SEOHead from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import CategorySection from './components/CategorySection';
import LatestSection from './components/LatestSection';
import PopularSection from './components/PopularSection';
import FAQSection from './components/FAQSection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '虚空韩漫网',
  url: 'https://xukonghanman.com/',
  description: '虚空韩漫网 - 免费韩漫在线阅读平台，提供高清下拉式韩漫全集和韩国漫画免费读',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://xukonghanman.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '虚空韩漫网',
  url: 'https://xukonghanman.com/',
  description: '免费韩漫在线阅读平台，提供高清下拉式韩漫全集',
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="虚空韩漫网_免费韩漫在线阅读平台_高清下拉式韩漫全集_韩国漫画免费读"
        description="虚空韩漫网是免费的韩漫在线阅读平台，提供高清下拉式韩漫全集和韩国漫画免费读。海量正版韩漫资源，每日更新，支持PC和移动端流畅阅读。"
        keywords="虚空韩漫网, 免费韩漫, 韩漫在线阅读, 高清下拉式韩漫, 韩漫全集, 韩国漫画免费读, 正版韩漫"
        canonicalUrl="https://xukonghanman.com/"
        ogType="website"
        schema={{ ...homeSchema, ...orgSchema }}
        breadcrumbItems={[{ name: '首页', url: 'https://xukonghanman.com/' }]}
      />

      <Navbar />

      <main>
        <HeroSection />
        <FeaturedSection />
        <CategorySection />
        <LatestSection />
        <PopularSection />
        <FAQSection />
      </main>

      <Footer />
    </>
  );
}